import React from 'react';

import { ArrowDown } from '@videoblocks/react-icons';

export default function RightArrowButton() {
  return (
    <button
      type="submit"
      className="rounded-full border-none h-14 w-14 p-4 bg-gray-400 mr-2 my-2 hidden md:block cursor-pointer transition-colors duration-300 ease-in-out hover:bg-gray-900 flex-shrink-0 flex-grow-0"
      aria-label="Submit Search"
    >
      <ArrowDown className="transform -rotate-90 fill-white" />
    </button>
  );
}
